module.exports = __webpack_public_path__ + "img/14.a5bf1ad9.jpg";